import React from 'react';
export function Footer() {
  return <footer className="bg-[#3a3631] text-gray-300 py-6" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-sm text-center" data-id="element-24">
          <p data-id="element-25">&copy; 2025 Materrea. Tous droits réservés.</p>
        </div>
      </div>
    </footer>;
}